import { Component } from '@angular/core';

@Component({
    selector: 'app-announcements',
    templateUrl: './announcements.component.html',
    styleUrl: './announcements.component.css',
    standalone: false
})
export class AnnouncementsComponent {
  isListView = true; // Default view is List

  toggleView() {
    this.isListView = !this.isListView;
  }
}
